import { render, staticRenderFns } from "./keywordAnalysis.vue?vue&type=template&id=b3aed1be&scoped=true"
import script from "./keywordAnalysis.vue?vue&type=script&lang=js"
export * from "./keywordAnalysis.vue?vue&type=script&lang=js"
import style0 from "./keywordAnalysis.vue?vue&type=style&index=0&id=b3aed1be&prod&scoped=true&lang=css"
import style1 from "./keywordAnalysis.vue?vue&type=style&index=1&id=b3aed1be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3aed1be",
  null
  
)

export default component.exports